import { useEffect } from 'react'
import { ScoopButton, ScoopSelector } from '../../../../ui'
import { TimeAnalysisResult } from '../TimeAnalysisResult/TimeAnalysisResult'
import { TimeRangeControl } from '../../../../Insights/TimeRangeControl.jsx'
import styles from './TimeAnalysis.module.scss'
import { useModal } from '../../../../modals/useModal'
import { MODALS } from '../../../../modals/ModalRegistry'

export const TimeAnalysis = ({ mlResults, selectedInbox, analyze, mlConfig, setMlConfig }) => {
    const timeRangeModal = useModal(MODALS.COMMON.TIME_RANGE)

    useEffect(() => {
        if (selectedInbox?.tables?.[0]?.dates?.length > 0) {
            mlConfig.dateToUse = selectedInbox.tables[0].dates[0]
            setMlConfig({ ...mlConfig })
        }
    }, [selectedInbox])

    let disabled =
        mlConfig && mlConfig.periodOneConfig.timeRange === mlConfig.periodTwoConfig.timeRange

    return (
        <>
            {!mlResults && (
                <div className={styles.container}>
                    <p className={styles.description}>
                        This machine learning analysis will attempt to find meaningful differences
                        in the data between two time periods. This can help uncover if something
                        unusual happened in one period versus another.
                    </p>
                    <div className={styles.dateRow}>
                        <p className={styles.dateLabel}>Pick the date to use for comparison:</p>
                        <ScoopSelector
                            removeMargin
                            value={mlConfig.dateToUse}
                            labelClassName={'selector-label-bold'}
                            size="sm"
                            onChange={(e) => {
                                mlConfig.dateToUse = e.target.value
                                setMlConfig({ ...mlConfig })
                            }}
                            options={
                                selectedInbox?.tables?.[0]?.dates?.map((col) => ({
                                    label: col,
                                    value: col,
                                })) || []
                            }
                        />
                    </div>
                    <div className={styles.periodOneRow}>
                        <p className={styles.periodLabel}>Time Period to Analyze:</p>
                        <TimeRangeControl
                            config={mlConfig.periodOneConfig}
                            setConfig={(newConfig) => {
                                mlConfig.periodOneConfig = newConfig
                                setMlConfig({ ...mlConfig })
                            }}
                            onOpenTimeRange={() =>
                                timeRangeModal.show({
                                    config: mlConfig.periodOneConfig,
                                    setConfig: (newConfig) => {
                                        mlConfig.periodOneConfig = newConfig
                                        setMlConfig({ ...mlConfig })
                                    },
                                })
                            }
                            controlHeight={40}
                            controlWidth={200}
                        />
                    </div>
                    <div className={styles.periodTwoRow}>
                        <p className={styles.periodLabel}>Compare to Period:</p>
                        <TimeRangeControl
                            config={mlConfig.periodTwoConfig}
                            setConfig={(newConfig) => {
                                mlConfig.periodTwoConfig = newConfig
                                setMlConfig({ ...mlConfig })
                            }}
                            onOpenTimeRange={() =>
                                timeRangeModal.show({
                                    config: mlConfig.periodTwoConfig,
                                    setConfig: (newConfig) => {
                                        mlConfig.periodTwoConfig = newConfig
                                        setMlConfig({ ...mlConfig })
                                    },
                                })
                            }
                            controlHeight={40}
                            controlWidth={200}
                        />
                    </div>
                </div>
            )}
            <TimeAnalysisResult mlResults={mlResults} />
            {!mlResults && (
                <ScoopButton
                    onClick={() => {
                        let jsonBody = {
                            action: 'comparePeriods',
                            dateToUse: mlConfig.dateToUse,
                            periodOne: {
                                timeRange: mlConfig.periodOneConfig.timeRange,
                            },
                            periodTwo: {
                                timeRange: mlConfig.periodTwoConfig.timeRange,
                            },
                        }
                        if (mlConfig.periodOneConfig.timeRange === 'Custom') {
                            jsonBody.periodOne.fromPeriod = mlConfig.periodOneConfig.fromPeriod
                            jsonBody.periodOne.toPeriod = mlConfig.periodOneConfig.toPeriod
                            jsonBody.periodOne.start = mlConfig.periodOneConfig.from
                            jsonBody.periodOne.end = mlConfig.periodOneConfig.to
                        }
                        if (mlConfig.periodTwoConfig.timeRange === 'Custom') {
                            jsonBody.periodTwo.fromPeriod = mlConfig.periodTwoConfig.fromPeriod
                            jsonBody.periodTwo.toPeriod = mlConfig.periodTwoConfig.toPeriod
                            jsonBody.periodTwo.start = mlConfig.periodTwoConfig.from
                            jsonBody.periodTwo.end = mlConfig.periodTwoConfig.to
                        }
                        analyze(jsonBody)
                    }}
                    disabled={disabled}
                    variant="default"
                >
                    Analyze
                </ScoopButton>
            )}
        </>
    )
}
